import { getGlobalHandle } from '@lib-shared/helpers';

interface ISegmentOptions {
  integrations?: object;
  anonymousId?: string;
  context?: { traits: object };
}

export default class Segment {
  static page(
    category?: string,
    name?: string,
    properties?: Record<string, any>,
    options?: ISegmentOptions,
    callback?: () => void
  ): void {
    getGlobalHandle().analytics.page(category, name, properties, options, callback);
  }
  static identify(
    userId: string | undefined,
    traits: Record<string, any> = {},
    options?: ISegmentOptions,
    callback?: () => void
  ): void {
    if (userId) {
      getGlobalHandle().analytics.identify(userId, traits, options, callback);
    }
    getGlobalHandle().analytics.identify(traits, options, callback);
  }
  static group(
    groupId: string,
    traits?: Record<string, any>,
    options?: ISegmentOptions,
    callback?: () => void
  ): void {
    getGlobalHandle().analytics.group(groupId, traits, options, callback);
  }
  static track(
    event: string,
    properties?: Record<string, any>,
    options?: ISegmentOptions,
    callback?: () => void
  ): void {
    getGlobalHandle().analytics.track(event, properties, options, callback);
  }
  static reset(): void {
    getGlobalHandle().analytics.reset();
  }
}
